
import Vue from "vue"
import vueSmoothScroll from "vue2-smooth-scroll"

Vue.use(vueSmoothScroll)
import HelpCenterWrapper from "@/components/layout/HelpCenterWrapper"

export default {
    layout: "fullscreen",
    components: {
        HelpCenterWrapper,
    },
    head() {
        return {
            title: "Nutzungsbedingungen",
            meta: [
                {
                    hid: "og:title",
                    name: "og:title",
                    content: "Nutzungsbedingungen",
                },
            ],
        }
    },
}
